import React, { useState, useEffect } from 'react';
import { ScrollView, VStack, Divider } from 'native-base';

// Redux
import {
  useAppDispatch,
  openModal,
  useGetCurrentUserQuery,
} from '@breakroom-nx/redux';

// Assets & Icons
import { theme } from '@breakroom-nx/assets';

// Components
import {
  SecondaryButton,
  TertiaryButton,
  UserReferral,
  UserPrivacySettings,
  UserSecurity,
  UserPersonalSettings,
} from '../../';

export interface UserSettingsProps {
  onSignOut: any;
}

function UserSettings({ onSignOut }: UserSettingsProps) {
  const [signingOut, setSigningOut] = useState<boolean>(false);
  const [deletingAccount, setDeletingAccount] = useState<boolean>(false);

  const { data: user, isLoading, isError, refetch } = useGetCurrentUserQuery();

  // Redux
  const dispatch = useAppDispatch();

  const signOutUser = async () => {
    setSigningOut(true);
    onSignOut();
  };

  useEffect(() => {
    // console.log('Rendered User Settings');
    return () => {
      // console.log('Unmounted User Settings');
    };
  }, []);

  return (
    <ScrollView
      flex={1}
      showsVerticalScrollIndicator={true}
      _contentContainerStyle={{
        px: 8,
        pb: 150,
      }}
    >
      {user ? (
        <VStack width={'full'} space={8}>
          <UserPersonalSettings user={user} />
          <Divider bgColor={theme.colors.surface[200]} />
          <UserPrivacySettings />
          <Divider bgColor={theme.colors.surface[200]} />
          <UserSecurity />
          <Divider bgColor={theme.colors.surface[200]} />
          <VStack>
            <VStack alignItems={'flex-end'} mt={6}>
              <UserReferral />
            </VStack>
            <VStack space={3} mt={'40px'} alignItems={'center'}>
              <SecondaryButton
                text={'Log Out'}
                isLoading={signingOut}
                disabled={signingOut || deletingAccount}
                onPress={() => {
                  signOutUser();
                }}
                color={theme.colors.surface[600]}
                fontSize={14}
                bg={'transparent'}
                style={{
                  width: '80%',
                  borderWidth: 1,
                  borderColor: theme.colors.surface[200],
                }}
              />
              <TertiaryButton
                text={'Delete Account'}
                onPress={() => {
                  setDeletingAccount(true);
                  dispatch(openModal({ modalType: 'AccountDeletion' }));
                }}
                isLoading={deletingAccount}
                disabled={signingOut || deletingAccount}
                fontSize={14}
                style={{
                  color: 'red',
                }}
              />
            </VStack>
          </VStack>
        </VStack>
      ) : null}
    </ScrollView>
  );
}

const MemoUserSettings = React.memo(UserSettings);
export { MemoUserSettings };
